import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { EmployeeVisitDto } from 'src/api';

export interface EmployeeVisitsState extends EntityState<EmployeeVisitDto, number> {}

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'EmployeeVisits', cache: { ttl: 3600000 } })
export class EmployeeVisitsStore extends EntityStore<EmployeeVisitsState> {
  constructor() {
    super();
  }
}
